<div style="display:flex; flex-direction:column; justify-content:center; align-items:center">
    <div>
        <img src="../../../../assets/images/loading 1.png" alt="">
    </div>
    <p class="import-msg">Please wait while we generate your FlyCuts</p>
</div>